import { useContext, useEffect, useState } from 'react'
import { Box, Grid, Typography, Paper, Stack, Snackbar } from '@mui/material'

import RightPanel from '../rightPanel'
import ReferralHistory from './referralHistory'
import CustomToolTip from '../../common/toolTip'
import { DataContext } from '../../../contexts/data/dataContext'
import custom from '../../../styles/mui/szVariables.json'
import { analyticsPage, analyticsDomain, analyticsCta } from '../../../services/constants'
import { sendClickAnalytics, sendViewAnalytics } from '../../common/util/util'

export default function Referral() {
  const border = custom.border
  const data = useContext(DataContext)
  const [message, setMessage] = useState('')

  const handleCopy = async () => {
    sendClickAnalytics('/rightPanel', {
      domain: analyticsDomain.referFriends,
      name: analyticsCta.referFriendCopyCode,
      metadata: {},
    })
    try {
      await navigator.clipboard.writeText(`https://www.solarzero.co.nz/enquire?code=${data?.customer?.referralCode}`)
      setMessage('Copied to clipboard.')
    } catch (err) {
      console.error('Failed to copy text: ', err)
    }
  }

  useEffect(() => {
    sendViewAnalytics('/rightPanel', {
      domain: analyticsDomain.referFriends,
      name: analyticsPage.referFriends,
    })
  }, [])

  return (
    <RightPanel title="Refer-A-Friend">
      <Grid
        container
        direction="row"
        display="flex"
        alignContent={'center'}
        justifyContent={'center'}
        alignItems={'center'}
        pb={10}>
        <Grid
          item
          xs={12}
          m={custom.spacing.md}
          display="flex"
          alignContent={'center'}
          justifyContent={'center'}
          alignItems={'center'}>
          <Paper
            id="referAFriend"
            elevation={0}
            sx={{
              borderRadius: custom.corners5,
              border,
              boxSizing: 'border-box',
              p: custom.spacing.md,
              width: '100%',
            }}>
            <Box>
              <Stack alignItems="center" pb={custom.spacing.md}>
                <Box
                  component={'img'}
                  pb={custom.spacing.xxs}
                  alt="Refer a friend icon"
                  src="/images/ReferAFriendIcon.svg"
                />
                <Typography variant="szHeading.Bold.Medium" textAlign={'center'}>
                  {data?.referFriend?.prompt}
                </Typography>
              </Stack>
              {data?.referFriend?.steps.map((step: any, i: number) => (
                <Stack direction="row" alignItems="center" justifyContent="space-between" key={i}>
                  <Stack direction="column" alignItems="center" justifyContent="space-between" mr={custom.spacing.sm}>
                    <Box
                      display="flex"
                      justifyContent={'center'}
                      border={border}
                      height={custom.sizes.lg}
                      width={custom.sizes.lg}
                      sx={{
                        backgroundColor: 'primary.main',
                        borderRadius: 99,
                        mr: custom.spacing.xxs,
                      }}>
                      <Typography
                        pt={custom.spacing.xxxs}
                        color="#FFF"
                        lineHeight={'130%'}
                        variant="szBody.Regular.Medium"
                        textAlign={'center'}>
                        {step?.number}
                      </Typography>
                    </Box>
                  </Stack>
                  <Stack
                    direction="column"
                    alignItems="left"
                    justifyContent="space-between"
                    pt={custom.spacing.sm}
                    pb={custom.spacing.xxs}>
                    <Typography variant="szHeading.Bold.xSmall">{step?.title}</Typography>
                    <Typography variant="szBody.Regular.Small">{step?.description}</Typography>
                  </Stack>
                </Stack>
              ))}
              <Paper
                elevation={0}
                sx={{
                  borderRadius: custom.corners3,
                  border,
                  boxSizing: 'border-box',
                  mt: custom.spacing.md,
                  height: custom.sizes.xxl,
                }}>
                <Stack direction="row" alignItems={'center'} height={custom.sizes.xxl}>
                  <Box p={custom.spacing.sm} sx={{ cursor: 'pointer' }} id="referralCode" onClick={handleCopy}>
                    <Typography variant="szHeading.Bold.Medium">{data?.customer?.referralCode}</Typography>
                  </Box>
                  <Box
                    ml="auto"
                    width={custom.sizes.xl}
                    height={custom.sizes.xxl}
                    borderLeft={border}
                    sx={{ cursor: 'pointer' }}
                    id="copyButton"
                    onClick={handleCopy}>
                    <CustomToolTip message="Click here to copy referral url to clipboard.">
                      <Box
                        m={custom.spacing.xs}
                        pt={custom.spacing.xxxs}
                        component="img"
                        src="/images/LinkSimple.svg"
                      />
                    </CustomToolTip>
                  </Box>
                </Stack>
                <Snackbar
                  autoHideDuration={3000}
                  open={!!message}
                  onClose={() => setMessage('')}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  sx={{
                    position: 'relative',
                  }}>
                  <Box
                    p={custom.spacing.xxs}
                    sx={{
                      backgroundColor: 'sz.colors.gray600',
                      borderRadius: custom.corners2,
                    }}>
                    <Typography color="#FFF" variant="szBody.Regular.xxSmall">
                      {message}
                    </Typography>
                  </Box>
                </Snackbar>
              </Paper>
              <Stack alignItems="center" mt={custom.spacing.sm}>
                <Stack
                  direction="row"
                  sx={{ cursor: 'pointer' }}
                  onClick={() => {
                    sendClickAnalytics('/rightPanel', {
                      domain: analyticsDomain.referFriends,
                      name: analyticsCta.termsAndCondition,
                      metadata: {},
                    })
                    window.open(
                      'https://www.solarzero.co.nz/terms-and-conditions#tabs-af4f83be74-item-9522078477-tab',
                      '_blank'
                    )
                  }}>
                  <Typography variant="szBody.Regular.Small" sx={{ color: 'text.tertiary' }} pr={custom.spacing.xxs}>
                    Terms and conditions apply
                  </Typography>
                  <Box
                    component={'img'}
                    id="tandcButton"
                    p={custom.spacing.xxxxs}
                    alt="Pop out icon"
                    src="/images/PopOutIcon.svg"
                  />
                </Stack>
              </Stack>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} px={custom.spacing.md} mt={2}>
          <Typography variant="szBody.Regular.Medium" align="left">
            Your referrals
          </Typography>
        </Grid>
        {data?.customer?.referralHistory?.length > 0 ? (
          <ReferralHistory />
        ) : (
          <>
            <Typography variant="szBody.Regular.Small" align="center" sx={{ color: 'text.tertiary' }} mt={3}>
              You haven't made any referrals yet
            </Typography>
          </>
        )}
      </Grid>
    </RightPanel>
  )
}
